module.exports = __webpack_public_path__ + "media/images/achievement_category/board_answer_count-d79b21483bc8eede208bf0e0dede0f24.png";